import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {ReadonlyService} from './readonly.service';

/**
 * Base class for CRUD services.
 *
 * @typeParam T - the entity class type.
 * @param <K> - the ID class type.
 */
export abstract class BaseService<T, K> extends ReadonlyService<T, K> {

  protected constructor(http: HttpClient, baseURL: string) {
    super(http, baseURL);
  }

  create(object: T): Observable<T> {
    return this.http.post<T>(this.baseURL, object);
  }

  update(object: T): Observable<T> {
    return this.http.put<T>(this.baseURL, object);
  }

  delete(id: K): Observable<void> {
    return this.http.delete<void>(`${this.baseURL}/${id}`);
  }
}
